module.exports = __webpack_public_path__ + "static/media/62.c08b6ced.jpg";